import React, { useEffect, useState } from 'react'
import axiosClient from 'axios-client'
import { useStateContext } from 'context/ContextProvider'
import AddButton from 'components/Buttons/Add/AddButton'
import style from 'assets/css/Table.module.css'
import Filter from 'components/Filter'
import { Client, Id, Status, Subscription } from 'types'
import { Link } from 'react-router-dom'
import { Table, TableColumnsType, Tag as AntTag } from 'antd'
import TableOptions from 'components/Table/TableOptions'
import CustomTag from 'components/Buttons/Tag/CustomTag'
import { updateObject } from 'utils/updateObjectList'

const columns: TableColumnsType<Client> = [
  {
    title: 'Full Name',
    dataIndex: 'name',
    key: 'name',
    render: (_, { id, name }) => (
      <Link
        className={style.title}
        to={'/clients/view/' + id}
      >
        {name}
      </Link>
    ),
  },
  {
    title: 'Subscription',
    dataIndex: 'subscription',
    key: 'subscription',
    render: subscription => <AntTag color="magenta">{subscription}</AntTag>,
  },
  {
    title: 'Manager',
    dataIndex: 'manager',
    key: 'manager',
    render: (_, { manager }) => (
      <>{manager?.lastname && <div className={style.manager}>{manager.lastname}</div>}</>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: status => <CustomTag>{status}</CustomTag>,
  },
]

const Clients: React.FC = () => {
  const [clients, setClients] = useState<Client[]>([])

  // Get enums
  const subs = Object.values(Subscription)
  const statusVal = Object.values(Status)
  // Datalist suggestions
  const suggestions: (Subscription | Status)[] = [...statusVal, ...subs]

  const [selectedClients, setSelectedClients] = useState<Id[]>([])

  // rowSelection object indicates the need for row selection
  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: Client[]) => {
      //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      setSelectedClients(selectedRowKeys as Id[])
    },
  }

  const updateClientStatus = (field: string, newStatus: string) => {
    // Find the account by its ID
    const updatedAccounts = updateObject<Client>({
      objects: clients,
      selectedIds: selectedClients,
      updateProperty: field,
      updateValue: newStatus,
    })

    // Update the state with the modified accounts array
    setClients(updatedAccounts)
  }

  useEffect(() => {
    getClients([])
  }, [])

  const getClients = (filters: string[]) => {
    axiosClient
      .get('/clients', {
        params: {
          filters: filters,
        },
      })
      .then(({ data }) => {
        setClients(data)
      })
  }

  return (
    <>
      <div className={style.page_title}>
        <div className={style.label}>Clients</div>
        <div className={style.count}>{clients?.length} clients</div>
        {clients && clients.length > 0 && (
          <div style={{ marginLeft: 'auto' }}>
            <AddButton text="Client" />
          </div>
        )}
      </div>
      <div className={style.box}>
        <Filter
          setFilters={getClients}
          suggestions={suggestions.sort()}
        />
        <Table
          columns={columns}
          dataSource={clients}
          rowSelection={{
            type: 'checkbox',
            fixed: true,
            ...rowSelection,
          }}
          pagination={{
            position: ['bottomCenter'],
            pageSizeOptions: [10, 20, 50],
            showSizeChanger: true,
          }}
          locale={{
            emptyText: (
              <div className={style.no_record}>
                <div className={style.text_wrapper}>
                  No client yet! Please click on the button bellow to add new client.
                </div>
                <AddButton text="Client" />
              </div>
            ),
          }}
          //loading={true}
          rowKey={record => record.id}
          className={`${style.antTable}`}
          rowClassName={`${style.antRow}`}
          bordered
        />

        <TableOptions
          selectedRows={selectedClients}
          type="clients"
          updateObject={updateClientStatus}
        />
      </div>
    </>
  )
}

export default Clients
